export class Login {
    public email!: string;
    public Password!: string;
    public USERID!: number;
    public FullName!: string;
    public RoleId!: number;
    public LOC_CODE!: number;
}